"use strict";

exports.__esModule = true;
exports.createPermissionCheckerClientAPI = void 0;

var _forumPermissionChecker = require("@wix/communities-forum-universal/dist/src/services/permissions/forum-permission-checker");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Which permissions checker should I use?

* can - use when you only care about if user can do action or not - using this carries a message
  that action is visible only when user can actually do it.
* canRender - use it everywhere where you render UI based on permissions..*/
var resourcify = function resourcify(entity, resourceType) {
  return _objectSpread(_objectSpread({}, entity || {}), {}, {
    getResourceId: function getResourceId() {
      return resourceType;
    }
  });
};

var createPermissionsChecker = function createPermissionsChecker(permissions) {
  return function (permission, resourceType, entity) {
    return permissions.can(resourcify(entity, resourceType), permission);
  };
};

var createPermissionsRenderHelper = function createPermissionsRenderHelper(canChecker) {
  return function (checks, render) {
    var result = checks.map(function (_ref) {
      var permission = _ref[0],
          resource = _ref[1],
          obj = _ref[2];
      return canChecker(permission, resource, obj);
    });
    var can = result.some(function (r) {
      return r === true;
    });
    return can ? render(result) : null;
  };
};

var getUserSiteMemberId = function getUserSiteMemberId(user) {
  if (user && user.siteMemberId) return {
    siteMemberId: user.siteMemberId
  };
  if (user && user.id) return {
    siteMemberId: user.id
  };
  return {};
};

var userToRequestor = function userToRequestor(user, permissions) {
  var publicUserPrivateStatuses = ['PUBLIC', 'COMMUNITY'];
  var isPublicUser = user && publicUserPrivateStatuses.includes(user.privacyStatus);
  return _objectSpread(_objectSpread({
    permissions: permissions,
    groups: user && user.groups ? user.groups : [],
    type: isPublicUser ? 'MEMBER' : 'GUEST'
  }, getUserSiteMemberId(user)), user && user.userId && {
    userId: user.userId
  });
};

var categoryResolver = function categoryResolver(resolveCategory) {
  return function (resource) {
    if (resource.categoryId) {
      resource = resolveCategory(resource.categoryId);
    }

    return resource;
  };
};

var permissionsChecker = (0, _forumPermissionChecker.permissionsChecker)();

var createPermissionCheckerClientAPI = function createPermissionCheckerClientAPI(_ref2) {
  var user = _ref2.user,
      usersPermissions = _ref2.usersPermissions,
      getCategory = _ref2.getCategory;
  var requestor = userToRequestor(user, usersPermissions);
  var permissions = permissionsChecker.withContext(requestor, categoryResolver(getCategory));
  var canPermissionsHelper = createPermissionsChecker(permissions);
  var permissionsRenderHelper = createPermissionsRenderHelper(canPermissionsHelper);
  return {
    permissions: permissions,
    can: canPermissionsHelper,
    canRender: permissionsRenderHelper
  };
};

exports.createPermissionCheckerClientAPI = createPermissionCheckerClientAPI;